<template>
    <div class="home pure-g">
        
        <MainMenu class="pure-u-1-6"/>
         
        <div class="pure-u-5-6">
    
            <div id="myProfileFormBox" class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Willkommen {{ accountName }}</legend>
                        <p>{{ welocmeMessage }}<p>
                        <legend>Ger&auml;t anmelden</legend>
                        <p>Um ihr mobiles Ger&auml;t anzumelden können sie diese URL verwenden: {{ apiUrl }}</p>
                        <p>Oder sie k&ouml;nnen foldenden Barcode scannen:</p>
                        <vue-qr :text="apiUrl"></vue-qr>

                    </fieldset>
                </form>

            </div>        
        </div>

        
    </div>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue"
import VueQr from 'vue-qr'
import { getApiUrl } from '@/utils/api.js'
import { getJwt, getAccountName, getCustomerName, getRole } from '@/utils/auth.js'


export default {
    name: "mainView",
    components: {
        MainMenu,
        VueQr
    },
    mounted: function() {

        this.loadData()
    },
    data: function() {
        return {
          apiUrl: '',
          welocmeMessage: '',
          accountName: ''
        }  
    },
    methods: {

        loadData: function() {

            this.apiUrl = getApiUrl()
            this.accountName = getAccountName()

            if (getCustomerName() != null) {

                this.welocmeMessage = 'Sie sind in der Rolle ' + getRole() + ' für ' + getCustomerName() + ' angemledet.'

            } else {
                
                this.welocmeMessage = 'Sie sind in der Rolle ' + getRole() + ' angemeldet.'
            }

        }
    }
};
</script>

<style>

</style>